module.exports = __webpack_public_path__ + "static/media/flag-tk.4e083cf2.webp";